import { FooterLinkType } from "../types/footer";

export const footerLinkData: FooterLinkType[] = [
  {
    type: "external",
    link: "https://docs.domino.ai",
    title: "Latest Docs",
    badge: "New",
  },
  {
    type: "external",
    link: "https://domino.ai/",
    title: "Domino Data Lab",
  },
  {
    type: "external",
    link: "https://tickets.dominodatalab.com/",
    title: "Knowledge Base",
  },
  {
    type: "external",
    link: "https://domino.ai/blog/",
    title: "Data Science Blog",
  },
  {
    type: "external",
    link: "https://university.domino.ai/",
    title: "Training",
  },
];

